import * as React from "react";
import type { SVGProps } from "react";

const FacilitySupermarket = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M6.66667 14.5837L4.16667 2.91699H2.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.875 14.5837H15.2083"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="15.2083"
      cy="16.0423"
      r="1.45833"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="6.8763"
      cy="16.0423"
      r="1.45833"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.70312 5.41699H16.6669C16.9258 5.41699 17.17 5.53731 17.3278 5.7426C17.4855 5.94789 17.5388 6.21483 17.4722 6.46498L16.1393 11.465C16.042 11.8298 15.7116 12.0837 15.3341 12.0837H6.13171"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilitySupermarket.displayName = "FacilitySupermarket";

export default FacilitySupermarket;
